<app-header></app-header>
<section class="container clearfix pt-5 pb-5">
  <div class="row">
    <div
      class="col-12 col-md-12 col-lg-12 col-xl-12 offset-0 offset-md-0 offset-lg-0 offset-xl-0 mt-4 pb-3 text-md-left">
      <h1 data-animate-effect="fadeIn">Datos abiertos sobre salud pública, acciones sociales y gasto público en la
        Ciudad de México</h1>
      <img src="assets/images/paginas-datos02.png" width="100%" alt="" class="rounded-corners mt-4">
    </div>

    <!-- div
      class="col-12 col-md-12 col-lg-12 col-xl-12 offset-0 offset-md-0 offset-lg-0 offset-xl-0 mt-4 pb-3 text-md-left">
      <div class="alert alert-success p-4">
        <div class="row">
          <div class="col-12">
            <h1>¡Atención!</h1>
            <h4 class="mt-4">La información de este sitio está siendo actualizada, muy pronto estará disponible nuevamente!</h4>
            <hr>
            <p class="mt-5">El Portal de Datos Abiertos está cambiando. En la ADIP estamos trabajando para ofrecerle a la Ciudad de México un portal que ayude a transitar a cualquier persona de dudas sobre la CDMX a respuestas basadas en datos. </p>
            <a href="https://paginas.datos.cdmx.gob.mx/plan-accion">Leer más</a>
          </div>
        </div>
      </div>
    </div -->
    <div class="col-12 mt-5 mb-5">
      <div class="card rounded-corners border">
        <div class="card-body">
          <div class="row">
            <div class="col-8 text-left">
              <label class="control-label" style="margin-top: 8px; font-size: 19px;"><b>Datos de todos los casos asociados al COVID-19 en:</b></label>
            </div>
            <div class="col-4">
              <select class="" name="" class="form-control" (change)="ngTotals($event)">
                <option value="">Ciudad de México</option>
                <option [value]="alcaldia._id" *ngFor="let alcaldia of confirmados" >{{alcaldia.municipio_res}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card rounded-corners border" *ngIf="confirmadosTotal">
        <div class="card-body">
          <h2>{{confirmadosTotal | number: '1.0':'en-US'}}</h2>
          <p>Casos confirmados</p>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card rounded-corners border" *ngIf="negativosTotal">
        <div class="card-body">
          <h2>{{negativosTotal | number: '1.0':'en-US'}}</h2>
          <p>Casos negativos</p>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card rounded-corners border" *ngIf="sospechososTotal">
        <div class="card-body">
          <h2>{{sospechososTotal | number: '1.0':'en-US'}}</h2>
          <p>Casos sospechosos</p>
        </div>
      </div>
    </div>
    <div class="col-12 mt-4">
      <!-- div class="card rounded-corners-mid border mb-5">
        <div class="card-header bg-info text-light">
          <h4 class="ml-3 mt-3">
            <fa-icon [icon]="faInfoCircle"></fa-icon> Nota
          </h4>
        </div>
        <div class="card-body">
          <p class="mt-2 text-left">Actualización diaria elaborada con base en los datos abiertos y el diccionario de
            datos provista por el Gobierno Federal.</p>
          <h3 class="mt-4 mb-3">Información actualizada el día 24 de Enero del 2021 a las 18:00 hrs.</h3>
        </div>
      </div -->

      <div class="btn-group btn-group-lg w-100 mb-4 mt-4" role="group" aria-label="Basic example">
        <button type="button" class="btn btn-secondary btn-custom" (click)="toggleViz('activos')"
          [ngClass]="{'btn-green ': selectedViz == 'activos'}">Casos activos a nivel
          colonia</button>
        <button type="button" class="btn btn-secondary btn-custom" (click)="toggleViz('confirmados')"
          [ngClass]="{'btn-green': selectedViz == 'confirmados'}">Casos confirmados</button>
        <button type="button" class="btn btn-secondary btn-custom" (click)="toggleViz('hospitalizados')"
          [ngClass]="{'btn-green ': selectedViz == 'hospitalizados'}">Hospitalizados</button>
      </div>
      <div class="card rounded-corners border mb-3">
        <div class="card-body">
          <div *ngIf="selectedViz == 'activos'">
            <div *ngIf="casosColonia.filters">
              <app-mapa-colonias [colonias]="casosColonia"></app-mapa-colonias>
            </div>
          </div>
          <div *ngIf="selectedViz == 'confirmados'">
            <div *ngIf="casosAlcaldias.filters">
              <app-mapa-alcaldias [alcaldias]="casosAlcaldias"></app-mapa-alcaldias>
            </div>
          </div>

          <app-bar
            *ngIf="selectedViz == 'hospitalizados'"
            [containerId]="'bar01'"
            [vizName]="'Acumulado de hospitalizados'"
            [dataInput]="hospitalizados"
            [graphOptions]="'hospitalizados_totales'"
            [filterX]="'fecha'"
            [graph]="hospitalizados_totales_styles"
          ></app-bar>

          <app-bar
            *ngIf="selectedViz == 'hospitalizados'"
            [containerId]="'bar02'"
            [vizName]="'Intubados'"
            [dataInput]="hospitalizados"
            [graphOptions]="'camas_intubados_totales'"
            [filterX]="'fecha'"
            [graph]="hospitalizados_totales_styles"
          ></app-bar>
        </div>
      </div>

      <!-- div class="card rounded-corners border mb-3">
        <div class="card-header header-custom pt-4">
          <h2 class="text-light">Número de casos con síntomas declarados por fecha</h2>
        </div>
        <div class="card-body" *ngIf="casosAsociados.length>0">
          <app-bar
            [vizName]="'sintomas'"
            [dataInput]="casosAsociados"
            [graphOptions]="'resultado_lab'"
            [filterX]="'fecha_sintomas'"
            [graph]="hospitalizados_totales_styles"
          ></app-bar>
        </div>
      </div -->

      <!-- div class="card rounded-corners border mb-3">
        <div class="card-body" *ngIf="casosAsociados.length>0">
          <app-bar-chart [dataInput]="casosAsociados" [containerId]="intubadosId" [filterX]="filterIntubados"></app-bar-chart>
        </div>
      </div -->
    </div>

    <div class="col-12 mt-5 mb-5">
      <div class="card rounded-corners border">
        <div class="card-header">
          <h1 class="mt-3 mb-3">¿Cómo replicar estos resultados?</h1>
        </div>
        <div class="card-body p-4">
          <div class="row">
            <div class="col-12">
              <h4 class="mb-4 mt-3">Casos activos a nivel colonia</h4>
              <ul>
                <li>Base de referencia: Toma como referencia la base de "COVID-19 SINAVE CDMX".</li>
                <li>Casos Acivos: Son aquellos que cumplen las siguientes condiciones. Primero, que el resultado de
                  prueba definitivo es "SARS COV-2". Segundo, la fecha de inicio de síntomas es menor a 15 dís. Tercero,
                  se descartan los casos que han fallecido.</li>
              </ul>

              <h4 class="mb-4 mt-5">Datos agregados</h4>
              <ul>
                <li>Casos Confirmados: Toma como referencia la base de “Casos a nivel nacional asociados a covid-19”.
                  Selecciona aquellos casos cuya entidad de residencia (ENTIDAD RESIDENCIA) sea la Ciudad de México. Y
                  filtra por aquellos casos cuyo resultado (RESULTADO) sea “Positivo SARS-CoV-2”.</li>
                <li>Casos Negativos: Realiza los mismos pasos que para casos confirmados, pero en (RESULTADO) filtra por
                  “No positivo SARS-CoV-2”.</li>
                <li>Casos Sospechosos: Realiza los mismos pasos que para casos confirmados, pero en (RESULTADO) filtra
                  por “Resultado pendiente”.</li>
              </ul>

              <h4 class="mb-4 mt-5">Mapa de casos por alcaldía</h4>
              <ul>
                <li>Casos confirmados, negativos o sospechosos por alcaldía: Toma como referencia el tipo de caso que
                  quieres analizar. Filtra en la variable de municipio de residencia (MUNICIPIO RESIDENCIA) la alcaldía
                  que quieres analizar. Si quieres hacer un análisis geográfico, toma como referencia los “Límites de
                  las Alcaldías”.</li>
              </ul>

              <h4 class="mb-4 mt-5">Gráficas de casos hospitalizados en la CDMX</h4>
              <ul>
                <li>Casos de personas hospitalizados en la CDMX: Toma como referencia la base de “Personas
                  hospitalizadas por día por Covid-19”. Realiza una gráfica de columnas. En el eje X selecciona la
                  variable fecha (por día) y en el eje Y la suma de la variable de casos hospitalizados en la CDMX
                  (hospitales_totales_cdmx). En la pestaña de “Analizar” de la base, puedes realizar y compartir esta
                  gráfica.</li>
                <li>Casos de personas intubadas en la CDMX: Realiza los mismos pasos que en el punto anterior, pero en
                  el eje Y grafica la suma de la variable de casos de personas intubadas en la CDMX
                  (camas_intubados_cdmx).</li>
              </ul>

              <h4 class="mb-4 mt-5">¿Tienes más dudas?</h4>
              <ul>
                <li>Te recomendamos consultar la pestaña de "Información" y el diccionario en cada conjunto de datos.
                </li>
                <li>Crea una sesión en Plaza Pública y utiliza el espacio espacial para que resolvamos tus dudas sobre
                  los datos de covid-19. Te responderemos en menos de una semana.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mb-5">
      <!-- h2 class="mb-3">Conjuntos de datos utilizados</h2 -->
      <h3>Salud pública</h3>
      <p>Comportamiento de la pandemia y la respuesta gubernamental para prevenir y atender contagios.</p>

      <ul class="list-unstyled related-links">
        <li><a href="https://datos.cdmx.gob.mx/dataset/base-covid-sinave" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Casos confirmados y sospechosos por COVID-19 (SINAVE)</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/mapa-covid" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Casos nacionales asociados a COVID-19</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/tamizajes-cdmx" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Resultados de tamizajes realizados</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/traslados-a-hospitales" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Traslados a hospitales</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/personas-hospitalizadas-en-hospitales-de-zmvm" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Reporte diario de personas hospitalizadas por COVID-19</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/capacidad-hospitalaria" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Capacidad Hospitales COVID-19</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/servicios-atencion-violencia-mujeres-durante-contingencia-covid19" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Servicios de atención a la violencia de género durante contingencia</a></li>
        <!-- li><a href="http://mapacovid.datos.cdmx.gob.mx/" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Casos activos de COVID-19 en Ciudad de México a nivel colonia</a></li -->
      </ul>
    </div>

    <div class="col-12 mb-5">
      <h3 class="mb-3">Acciones de gobierno</h3>
      <h4>Acciones gubernamentales a problemas sociales y económicos asociados a la pandemia.</h4>
      <p>Programas y acciones anunciados para atender problemas sociales y económicos asociados a la emergencia:</p>
      <ul class="list-unstyled related-links">
        <li><a href="https://datos.cdmx.gob.mx/dataset/inventario-medidas-contingencia-covid19" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Inventario de medidas anunciadas</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/afluencia-preliminar-en-transporte-publico" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Afluencia diaria en transporte público</a></li>
        <!-- --><li><a href="https://datos.cdmx.gob.mx/explore/dataset/estaciones-tp-temporalmente-cerradas-cdmx-covid-19/" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Estaciones de transporte público temporalmente cerradas</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/establecimientos-suspendidos-invea-covid19" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Establecimientos con suspensión de actividades ante la emergencia de COVID-19</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/comedores-sociales-que-dan-servicio-durante-crisis-covid-19" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Comedores Sociales que dan servicio ante la emergencia de COVID 19</a></li>
      </ul>
    </div>

    <div class="col-12 mb-5">
      <h3>Gasto público</h3>
      <p>Información para dar a conocer y explicar el uso dado a los recursos públicos para responder a la pandemia.</p>
      <ul class="list-unstyled related-links">
        <li><a href="https://datos.cdmx.gob.mx/dataset/contratos-adjudicados-covid19" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Contratos adjudicados para atender la emergencia sanitaria</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/inventario-de-acciones-y-programas-sociales-rendicion-de-cuentas" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Inventario de programas y acciones sociales</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/solicitudes-seguro-de-desempleo" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Solicitudes al Programa Seguro de Desempleo</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/solicitudes-financiamiento-microempresas" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Solicitudes al Programa de Financiamiento para Microempresas</a></li>
        <li><a href="https://datos.cdmx.gob.mx/dataset/apoyos-a-comerciantes-de-alimentos-preparados" target="_blank" rel="noopener"><fa-icon [icon]="faLink" class="text-success mr-3"></fa-icon>Apoyos Económicos Emergente para Personas que Ejercen el Comercio en Vía Pública</a></li>
      </ul>

    </div>

  </div>
</section>

<app-footer></app-footer>
